"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumeItemSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var formik_1 = require("formik");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
exports.ConsumeItemSchema = Yup.object().shape({
    destinationStockNumber: Yup.string().required(),
});
function EditReceiveItem(props) {
    var modalState = props.modalState, setModalState = props.setModalState, receiveItemDoc = props.receiveItemDoc;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(true), loaded = _a[0], setLoaded = _a[1];
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            receivedQuantity: 0,
            specification: "",
            destinationStockNumber: "",
            batchNumber: "",
            expiryDate: (0, moment_1.default)(),
        },
        validationSchema: exports.ConsumeItemSchema,
        onSubmit: function (values, form) {
            // warehouseTransferOperationsRef
            //   .doc(receiveItemDoc.id)
            //   .update({
            //     receivedQuantity: values.receivedQuantity,
            //     specification: values.specification ?? "",
            //     destinationStockNumber: values.destinationStockNumber,
            //     batchNumber: values.batchNumber,
            //     expiryDate: values.expiryDate.toDate() as any,
            //   })
            //   .then(() => {
            //     setModalState(false);
            //     message.success("Successfully Done!");
            //   })
            //   .catch(() => message.error("Something went wrong!"));
        },
    });
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (receiveItemDoc && loaded) {
            formProps.setValues({
                receivedQuantity: (_a = receiveItemDoc.receivedQuantity) !== null && _a !== void 0 ? _a : receiveItemDoc.quantity,
                specification: (_b = receiveItemDoc.specification) !== null && _b !== void 0 ? _b : "",
                destinationStockNumber: receiveItemDoc.destinationStockNumber,
                batchNumber: receiveItemDoc.batchNumber,
                expiryDate: (0, moment_1.default)(receiveItemDoc.expiryDate.toDate()),
            });
            setLoaded(false);
        }
    }, [receiveItemDoc, formProps, loaded]);
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ title: "Edit Receive Item", open: modalState, onOk: formProps.submitForm, 
        // okButtonProps={{ disabled: uploading }}
        onCancel: function () { return setModalState(false); } }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("destinationStockNumber").touched) &&
                        formProps.errors.destinationStockNumber &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("destinationStockNumber").touched) &&
                        formProps.errors.destinationStockNumber, label: t("warehouse.destinationStockNumber") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { placeholder: "Stock Number", style: { width: "200px" }, value: formProps.values.destinationStockNumber, onChange: function (e) {
                            return formProps.setFieldValue("destinationStockNumber", e.target.value);
                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("receivedQuantity").touched) &&
                        formProps.errors.receivedQuantity &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("receivedQuantity").touched) &&
                        formProps.errors.receivedQuantity, label: t("common.receivedQuantity") }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { disabled: false, type: "number", min: 0, max: receiveItemDoc.quantity, value: formProps.values.receivedQuantity, onChange: function (e) { return formProps.setFieldValue("receivedQuantity", e); } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("expiryDate").touched) &&
                        formProps.errors.expiryDate &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("expiryDate").touched) &&
                        formProps.errors.expiryDate, label: t("common.expiryDate") }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.expiryDate, onChange: function (e) { return formProps.setFieldValue("expiryDate", e); }, 
                        // style={{ width: '120px' }}
                        placeholder: "Expiry Date", allowClear: false }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("specification").touched) &&
                        formProps.errors.specification &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("specification").touched) &&
                        formProps.errors.specification, label: "Specification/Brand" }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { value: formProps.values.specification, onChange: function (e) {
                            return formProps.setFieldValue("specification", e.target.value);
                        }, style: { width: "135px" }, placeholder: "Specification" }) }))] })) })));
}
exports.default = EditReceiveItem;
